import { render } from "./AppMain.vue?vue&type=template&id=6fef277b&scoped=true"
import script from "./AppMain.vue?vue&type=script&lang=js"
export * from "./AppMain.vue?vue&type=script&lang=js"

import "./AppMain.vue?vue&type=style&index=0&id=6fef277b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6fef277b"

export default script